import React, { useRef, useEffect } from 'react';
import "./DisableReason.css"

const DisablePopUp = ({ onClose, disabledDate, disabledReason, description }) => {
    const modalRef = useRef(null);

    // Close the modal if the user clicks outside of it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div className='disable-modal'>
            <div ref={modalRef} className='disable-modal-container'>
                <div className="user-status-container">
                    <table className="user-status-table">
                        <tbody>
                            <tr>
                                <td className="user-status-text">User Disabled</td>
                            </tr>
                        </tbody>
                    </table>
                    <button className='user-status-close-Icon' onClick={onClose}>&times;</button>
                </div>
                <div className="lead-status-container">
                    <table>
                        <tbody>
                            <tr>
                                <td className="lead-status-text">
                                    <b>Disabled Date:</b> {disabledDate} <br /><br />
                                    <b>Disabled Reason:</b> {disabledReason} <br /><br />
                                    {description}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DisablePopUp;